import Stomp from 'stompjs';
import store from '../store';
import { getToken } from './auth'
import { getLanguageName, getDefaultLanguage as getDefaultLang } from '../i18n/languages'



export function initWebSocket(id, websocketonmessage, websocketonerror) {
  let socketUrl = '';
  if (process.env.NODE_ENV == 'development') {
    socketUrl = process.env.VUE_APP_WEBSOCKET_URL;
  } else {
    let host = window.location.host;
    let href = window.location.href;
    socketUrl = (href.indexOf('https:') == 0 ? 'wss://' : 'ws://') + host + '/ws';
  }
  return new Promise((resolve, reject) => {
    const client = Stomp.client(socketUrl);
    client.debug = false
    client.connect({
      debug: false,
      host: 'hb-v3'
    }, () => {
      console.log("onConnect")
      client.subscribe('/queue/' + id, message => {
        websocketonmessage({
          data: message.body
        });
      })
      resolve(client)
    }, (error) => {
      console.log(error)
      if (websocketonerror) {
        websocketonerror(error)
      }
      reject(error)
    })

  })
}


// 数字格式化
export function formatNumber(num) {
  return parseFloat(num).toFixed(8)
}

// 智能金额格式化 - 根据数值大小自动选择最佳显示格式
export function formatAmount(amount) {
  if (!amount) return '0'

  // 转换为字符串并去除前后空格
  let amountStr = String(amount).trim()

  // 如果是负数，取绝对值
  if (amountStr.startsWith('-')) {
    amountStr = amountStr.substring(1)
  }

  const num = parseFloat(amountStr)
  if (isNaN(num) || num === 0) return '0'

  // 如果是整数，直接返回
  if (num % 1 === 0) {
    return num.toString()
  }

  // 转换为字符串进行处理
  let numStr = num.toString()

  // 如果包含科学计数法，先转换为固定小数位
  if (numStr.includes('e') || numStr.includes('E')) {
    numStr = num.toFixed(8)
  }

  // 去除末尾的0
  numStr = numStr.replace(/\.?0+$/, '')

  // 如果小数位数少于等于4位，直接返回
  const decimalIndex = numStr.indexOf('.')
  if (decimalIndex === -1) {
    return numStr
  }

  const decimalPart = numStr.substring(decimalIndex + 1)

  // 如果小数位数少于等于4位，直接返回
  if (decimalPart.length <= 4) {
    return numStr
  }

  // 如果小数位数大于4位，检查前4位是否都是0
  const first4Decimals = decimalPart.substring(0, 4)
  if (first4Decimals === '0000') {
    // 前4位都是0，显示更多位数直到遇到非0数字
    let significantIndex = 0
    for (let i = 0; i < decimalPart.length; i++) {
      if (decimalPart[i] !== '0') {
        significantIndex = i
        break
      }
    }
    // 显示到第一个有效数字后1位，但最多8位
    const endIndex = Math.min(significantIndex + 2, 8)
    return numStr.substring(0, decimalIndex + 1 + endIndex)
  } else {
    // 前4位不全是0，显示4位小数
    return numStr.substring(0, decimalIndex + 5)
  }
}

export function getLocalName(key) {
  return getLanguageName(key)
}

// 默认语言（保持向后兼容）
export function getDefaultLanguage() {
  return getDefaultLang()
}

export function resetEmail(email) {
  if (!email) {
    return ''
  }
  let newEmail = ''
  let pre = email.substring(0, email.indexOf('@'))
  if (pre.length > 4) {
    pre = pre.substring(0, 2) + '****' + pre.substring(pre.length - 2)
  } else {
    pre = pre.substring(0, 1) + '****' + pre.substring(pre.length - 1)
  }
  newEmail = pre + email.substring(email.indexOf('@'))
  return newEmail
}

export function resetName(name) {
  if (!name) {
    return ''
  }
  let newName = ''
  if (name.length > 2) {
    newName = name.substring(0, 2) + '****'
  } else {
    newName = name.substring(0, 1) + '****'
  }
  return newName
}

export function sortByField(list, fieldName, order = 'asc') {
  return list.sort((a, b) => {
    if (a[fieldName] < b[fieldName]) {
      return order === 'asc' ? -1 : 1;
    }
    if (a[fieldName] > b[fieldName]) {
      return order === 'asc' ? 1 : -1;
    }
    return 0;
  });
}